import React, { useState } from 'react';
import { Routes, Route, Navigate, useLocation, Link, useNavigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import LoginPage from './pages/LoginPage';
import Dashboard from './pages/Dashboard';
import Balances from './pages/Balances';
import Attendance from './pages/Attendance';
import Matrimony from './pages/Matrimony';
import Finances from './pages/Finances';
import Health from './pages/Health';
import { ThemeProvider } from '@mui/material/styles';
import {
  AppBar, Toolbar, Typography, Container, CssBaseline, Button,
  IconButton,
  Drawer, List, ListItemButton, ListItemText, useMediaQuery,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { appTheme } from './theme';

function RequireAuth({ children }) {
  const { token } = useAuth();
  const location = useLocation();
  if (!token) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }
  return children;
}

const navItems = [
  { to: '/dashboard', label: 'Home' },
  { to: '/balances', label: 'Balances' },
  { to: '/finances', label: 'Finances' },
  { to: '/health', label: 'Health' },
  { to: '/attendance', label: 'Attendance' },
  { to: '/matrimony', label: 'Matrimony' },
];

function NavLinks({ onClick }) {
  const location = useLocation();
  const navigate = useNavigate();
  const go = (to) => {
    onClick?.();
    navigate(to);
  };
  return navItems.map(({ to, label }) => (
    <ListItemButton key={to} selected={location.pathname === to} onClick={() => go(to)}>
      <ListItemText primary={label} />
    </ListItemButton>
  ));
}

export default function App() {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const isMobile = useMediaQuery(appTheme.breakpoints.down('sm'));

  return (
    <AuthProvider>
      <ThemeProvider theme={appTheme}>
        <CssBaseline />
        <AppBar position="static" elevation={0} sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Toolbar sx={{ minHeight: { xs: 56 }, px: { xs: 1 } }}>
            {isMobile && (
              <IconButton color="inherit" edge="start" onClick={() => setDrawerOpen(true)} sx={{ mr: 1 }}>
                <MenuIcon />
              </IconButton>
            )}
            <Typography variant="h6" sx={{ flexGrow: 1 }} component={Link} to="/dashboard" color="inherit" style={{ textDecoration: 'none' }}>
              Dashboard
            </Typography>
            {!isMobile && navItems.map(({ to, label }) => (
              <Button key={to} color="inherit" component={Link} to={to} sx={{ mx: 0.5 }}>{label}</Button>
            ))}
          </Toolbar>
        </AppBar>
        <Drawer open={drawerOpen} onClose={() => setDrawerOpen(false)} anchor="left" PaperProps={{ sx: { width: 240, bgcolor: 'background.paper' } }}>
          <Toolbar />
          <List><NavLinks onClick={() => setDrawerOpen(false)} /></List>
        </Drawer>
        <Container maxWidth="lg" sx={{ py: { xs: 2, sm: 3 }, px: { xs: 1.5, sm: 2 } }}>
          <Routes>
            <Route path="/" element={<LoginPage />} />
            <Route path="/dashboard" element={<RequireAuth><Dashboard /></RequireAuth>} />
            <Route path="/balances" element={<RequireAuth><Balances /></RequireAuth>} />
            <Route path="/finances" element={<RequireAuth><Finances /></RequireAuth>} />
            <Route path="/health" element={<RequireAuth><Health /></RequireAuth>} />
            <Route path="/attendance" element={<RequireAuth><Attendance /></RequireAuth>} />
            <Route path="/matrimony" element={<RequireAuth><Matrimony /></RequireAuth>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Container>
      </ThemeProvider>
    </AuthProvider>
  );
}
